import { render, staticRenderFns } from "./buildings.vue?vue&type=template&id=4c335035&"
import script from "./buildings.vue?vue&type=script&lang=js&"
export * from "./buildings.vue?vue&type=script&lang=js&"
import style0 from "./buildings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports